{
  "name": "@kenkaiiii/gg-boss",
  "version": "5.9.6",
  "type": "module",
  "description": "Orchestrator agent that drives multiple ggcoder sessions across projects from a single chat",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/kenkaiiii/gg-framework.git",
    "directory": "packages/gg-boss"
  },
  "bin": {
    "ggboss": "./dist/cli.js"
  },
  "exports": {
    ".": "./dist/index.js"
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup && cp -R assets/. dist/ && chmod +x dist/cli.js",
    "check": "tsc --noEmit",
    "test": "vitest run"
  },
  "devDependencies": {
    "@kenkaiiii/gg-agent": "workspace:*",
    "@kenkaiiii/gg-ai": "workspace:*",
    "@kenkaiiii/gg-core": "workspace:*",
    "@kenkaiiii/ggcoder": "workspace:*",
    "@types/node": "^25.6.0",
    "@types/react": "^19.2.14",
    "chalk": "^5.6.2",
    "ink": "npm:@kenkaiiii/ink@6.8.0-gg.2",
    "react": "^19.2.5",
    "tsup": "^8.5.1",
    "typescript": "^6.0.3",
    "vitest": "^4.1.4",
    "zod": "^4.4.3"
  },
  "optionalDependencies": {
    "@huggingface/transformers": "^3.6.0",
    "ogg-opus-decoder": "^1.6.13"
  },
  "publishConfig": {
    "access": "public"
  }
}
